import React, { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';
import { Box, Paper, Stack, Typography, Divider, Skeleton, Button, LinearProgress } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { DATE_FORMATER } from '../../../constants';
import { eventSentence } from './labels';

interface AuditTabProps { campaign: any; }

const PAGE_SIZE = 50;

const formatDateTime = (iso?: string | null) => (iso ? new Date(iso).toLocaleString('pt-BR', DATE_FORMATER as any) : '—');

/** Aba Auditoria (spec §8.3): eventos em ordem cronológica, um por linha, com a frase pronta de `eventSentence`. */
const AuditTab: React.FC<AuditTabProps> = ({ campaign }) => {
  const dataProvider = useDataProvider();
  const [events, setEvents] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!campaign?.id) return;
    setLoading(true);
    dataProvider
      .getList(`customer-recovery-rules/${campaign.id}/events`, {
        pagination: { page: 1, perPage: pages * PAGE_SIZE },
        sort: { field: 'createdAt', order: 'ASC' },
        filter: {},
      })
      .then(({ data, total: t }: any) => {
        setEvents(data || []);
        setTotal(t || (data || []).length);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [campaign?.id, pages, dataProvider]);

  if (loading && events.length === 0) return <Skeleton variant="rectangular" height={240} sx={{ my: 2 }} />;

  if (events.length === 0) {
    return <Typography color="text.secondary" p={2}>Sem eventos ainda.</Typography>;
  }

  return (
    <Box sx={{ py: 2 }}>
      <Stack spacing={1.5}>
        {events.map((event: any) => (
          <Paper key={event.id} variant="outlined" sx={{ p: 1.5, display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <HistoryIcon fontSize="small" color="primary" sx={{ mt: 0.25 }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2">{eventSentence(event)}</Typography>
              <Typography variant="caption" color="text.secondary">{formatDateTime(event.createdAt)}</Typography>
            </Box>
          </Paper>
        ))}
      </Stack>

      {loading && events.length > 0 && <LinearProgress sx={{ mt: 1.5 }} />}

      {!loading && events.length < total && (
        <>
          <Divider sx={{ my: 1.5 }} />
          <Box textAlign="center">
            <Button size="small" onClick={() => setPages((p) => p + 1)}>Carregar mais</Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default AuditTab;
